'use strict';

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var ValidationBag = require('./validation-bag');

var Rule = require('./rule');

var Validator = require('./validator');

var mixin = require('./mixin');

var utils = require('./utils');
/* plugin install
 ----------------------------------- */


function install(Vue, options) {
  Vue.mixin(mixin);

  if (options && options.templates) {
    extendTemplates(options.templates);
  }

  if (options && options.mode) {
    setMode(options.mode);
  }
}

function extendTemplates(newTemplates) {
  var _context;

  _forEachInstanceProperty(_context = _Object$keys(newTemplates)).call(_context, function (key) {
    utils.templates[key] = newTemplates[key];
  });
}

function setMode(mode) {
  if (mode !== 'interactive' && mode !== 'conservative' && mode !== 'manual') {
    throw new Error('Invalid mode: ' + mode);
  }

  utils.mode = mode;
}
/* exports
 ----------------------------------- */


module.exports.name = 'SimpleVueValidator';
module.exports.ValidationBag = ValidationBag;
module.exports.Rule = Rule;
module.exports.Validator = Validator;
module.exports.mixin = mixin;
module.exports.install = install;
module.exports.extendTemplates = extendTemplates;
module.exports.setMode = setMode;